<template>
  <div class="tabs">
    <div class="mr-12 sm:mr-0">
      <ul
        class="nav nav-tabs"
        role="tablist"
      >
        <li
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            tabindex="-1"
            aria-selected="false"
            aria-setsize="2"
            aria-posinset="1"
            :class="{ active: activeTab === 'boarding' }"
            data-i18n="boardingLocations"
            @click.prevent="activeTab = 'boarding'"
          >{{ $t('boardingLocations') }}</a>
        </li>
        <li
          v-if="trainHome.length || trainOut.length"
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            tabindex="-1"
            aria-selected="false"
            aria-setsize="2"
            aria-posinset="2"
            :class="{ active: activeTab === 'train' }"
            data-i18n="trainConnections"
            @click.prevent="activeTab = 'train'"
          >{{ $t('trainConnections') }}</a>
        </li>
        <li
          v-if="overnightGothenburg.length > 0 || overnightMalmo.length > 0"
          class="nav-item"
          role="presentation"
        >
          <a
            class="nav-link"
            role="tab"
            tabindex="-1"
            aria-selected="false"
            aria-setsize="2"
            aria-posinset="3"
            :class="{ active: activeTab === 'overnight' }"
            data-i18n="boardingLocations"
            @click.prevent="activeTab = 'overnight'"
          >{{ $t('boardingLocations') }}</a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div
        class="tab-pane"
        :class="{ active: activeTab === 'boarding' }"
        role="tabpanel"
      >
        <ul class="mt-6 columns-3 departure-list">
          <li
            v-for="item in possiblePickups"
            :key="item.id"
          >
            <span>
              <strong>
                {{ item.time }}
              </strong>
              <span class="ml-2">
                {{ item.name_text }}
              </span>
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="trainHome.length || trainOut.length"
        class="tab-pane"
        :class="{ active: activeTab === 'train' }"
        role="tabpanel"
      >
        <div class="flex flex-wrap -mx-4 mt-6">
          <p
            class="w-12/12"
            data-i18n="trainConnectionsExplanation"
          >
            {{ $t('trainConnectionsExplanation') }}
          </p>
          <div class="w-6/12">
            <ul class="departure-list">
              <li
                v-for="t in trainOut"
                :key="t.product_id"
              >
                <strong class="mr-4">
                  {{ t.preliminary_time }}
                </strong>{{ t.name }} {{ $n(t.price) }}
              </li>
            </ul>
          </div>
          <div class="w-6/12">
            <ul class="departure-list">
              <li
                v-for="t in trainHome"
                :key="t.product_id"
              >
                <strong class="mr-4">
                  {{ t.preliminary_time }}
                </strong>{{ t.name }} {{ $n(t.price) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        v-if="overnightGothenburg.length > 0 || overnightMalmo.length > 0"
        class="tab-pane"
        :class="{ active: activeTab === 'overnight' }"
        role="tabpanel"
      >
        <LazyInfoModalOvernight
          :overnight-gothenburg="overnightGothenburg"
          :overnight-malmo="overnightMalmo"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },

    overnightGothenburg: {
      type: Array,
      required: true,
    },

    overnightMalmo: {
      type: Array,
      required: true,
    },

    possiblePickups: {
      type: Array,
      required: true,
    },

    trainMalmoOut: {
      type: Object,
      required: true,
    },

    trainMalmoHome: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      activeTab: 'boarding',
    }
  },

  computed: {
    trainOut () {
      return Object.keys(this.trainMalmoOut).map(k => this.trainMalmoOut[k])
    },

    trainHome () {
      return Object.keys(this.trainMalmoHome).map(k => this.trainMalmoHome[k])
    },
  },
})
</script>

<style lang="scss">
.departure-list {
  list-style-type: circle;
  padding: 0 1rem;
}
</style>
